import { useEffect } from 'react';

import { useBoundStore } from 'app/store';
import { CcrcModal } from 'widgets/Ccrc';

import { useSendCcrcInfo, useSuspenseData } from '../model';

export const Body = () => {
  const { hspId, hspCd, hspNm, usrId, userNm, ccrcTp, ptMpiKey } = useBoundStore(
    (state) => state['personalInfoAgree'].serviceParams,
  );
  const ccrcItemList = useSuspenseData({ hspId, hspCd, usrId, ccrcTp });

  const { data: resultData, mutate: sendPersonalInfo, isSuccess } = useSendCcrcInfo();
  useEffect(() => {
    document.querySelector('title').innerHTML = hspNm;
  }, []);

  const getContents = (ccrcTp) => {
    switch (ccrcTp) {
      case 'PAY':
        return {
          title: (
            <>
              {userNm}님의 진료비 결제를 위해 <br />
              개인정보 제3자 제공 동의가 필요해요
            </>
          ),
          desc: (
            <>
              케어챗의 진료비 결제 서비스를 이용하기 위한 목적으로 제공되고 다른 목적으로 이용되거나 외부에 노출되지
              않아요.
            </>
          ),
        };
      case 'PARK':
        return {
          title: (
            <>
              병원에 등록된 {userNm}님의 정보를 <br />
              조회하기 위한 동의가 필요해요
            </>
          ),
          desc: (
            <>
              제공해 주신 정보는 주차 편의 서비스 제공을 <br />
              위해서만 사용되며, 병원에서 안전하게 보관됩니다.
            </>
          ),
        };
      case 'HSPTZ':
        return {
          title: (
            <>
              병원에 등록된 {userNm}님의 정보를 <br />
              조회하기 위한 동의가 필요해요
            </>
          ),
          desc: (
            <>
              제공해 주신 정보는 입·퇴원 정보 조회와 편의 서비스 제공을 위해서만 사용되며, 병원에서 안전하게 보관됩니다.
            </>
          ),
        };
      default:
        return {
          title: (
            <>
              병원에 등록된 {userNm}님의 주소를 <br />
              {`${hspId === '11' ? '조회하기 위한' : '조회, 수정하기 위한'} 동의가 필요해요`}
            </>
          ),
          desc: (
            <>
              걱정마세요. 소중한 주소 정보는 검진결과서 외 우편물을 발송하거나, 응급상황 시 인근 병원으로의 호송 등을
              위해 진료기록부 관리 목적으로 활용되며, 병원에서 안전하게 보관됩니다.
            </>
          ),
        };
    }
  };

  const { title, desc } = getContents(ccrcTp);

  if (isSuccess) {
    const { result, redirectURL } = resultData.data;

    if (result === '0') {
      window.location.replace(redirectURL);
    }
  }

  return (
    <CcrcModal
      header={hspNm}
      title={title}
      desc={desc}
      hspCd={hspCd}
      hspId={hspId}
      ccrcItemList={ccrcItemList}
      handleClick={(ccrcResultList) => {
        sendPersonalInfo({
          hspId,
          hspCd,
          usrId,
          ccrcResultList,
          ptMpiKey,
          ccrcTp,
        });
      }}
    />
  );
};
